/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CandidateCompany from './CandidateCompany';
import Event from './Event';

/**
 * The CandidateOfferItem model module.
 * @module model/CandidateOfferItem
 * @version v1
 */
class CandidateOfferItem {
    /**
     * Constructs a new <code>CandidateOfferItem</code>.
     * Item ligero de oferta para listados vista candidato [P_A_02] [P_A_11]
     * @alias module:model/CandidateOfferItem
     */
    constructor() { 
        
        CandidateOfferItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CandidateOfferItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CandidateOfferItem} obj Optional instance to populate.
     * @return {module:model/CandidateOfferItem} The populated <code>CandidateOfferItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CandidateOfferItem();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('display_company_name')) {
                obj['display_company_name'] = ApiClient.convertToType(data['display_company_name'], 'Boolean');
            }
            if (data.hasOwnProperty('company')) {
                obj['company'] = CandidateCompany.constructFromObject(data['company']);
            }
            if (data.hasOwnProperty('company_name')) {
                obj['company_name'] = ApiClient.convertToType(data['company_name'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
            if (data.hasOwnProperty('modality')) {
                obj['modality'] = ApiClient.convertToType(data['modality'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('contract_type')) {
                obj['contract_type'] = ApiClient.convertToType(data['contract_type'], 'Number');
            }
            if (data.hasOwnProperty('length')) {
                obj['length'] = ApiClient.convertToType(data['length'], 'String');
            }
            if (data.hasOwnProperty('salary_type')) {
                obj['salary_type'] = ApiClient.convertToType(data['salary_type'], 'String');
            }
            if (data.hasOwnProperty('salary_min')) {
                obj['salary_min'] = ApiClient.convertToType(data['salary_min'], 'Number');
            }
            if (data.hasOwnProperty('salary_max')) {
                obj['salary_max'] = ApiClient.convertToType(data['salary_max'], 'Number');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('state')) {
                obj['state'] = ApiClient.convertToType(data['state'], 'String');
            }
            if (data.hasOwnProperty('is_remote_process')) {
                obj['is_remote_process'] = ApiClient.convertToType(data['is_remote_process'], 'Boolean');
            }
            if (data.hasOwnProperty('presence')) {
                obj['presence'] = ApiClient.convertToType(data['presence'], 'String');
            }
            if (data.hasOwnProperty('events')) {
                obj['events'] = ApiClient.convertToType(data['events'], [Event]);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('schedule')) {
                obj['schedule'] = ApiClient.convertToType(data['schedule'], 'Number');
            }
            if (data.hasOwnProperty('academic_matching')) {
                obj['academic_matching'] = ApiClient.convertToType(data['academic_matching'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
CandidateOfferItem.prototype['id'] = undefined;

/**
 * true: viene el company, false: viene el company_name
 * @member {Boolean} display_company_name
 */
CandidateOfferItem.prototype['display_company_name'] = undefined;

/**
 * @member {module:model/CandidateCompany} company
 */
CandidateOfferItem.prototype['company'] = undefined;

/**
 * @member {String} company_name
 */
CandidateOfferItem.prototype['company_name'] = undefined;

/**
 * @member {String} title
 */
CandidateOfferItem.prototype['title'] = undefined;

/**
 * @member {String} text
 */
CandidateOfferItem.prototype['text'] = undefined;

/**
 * normal, fct, dual
 * @member {String} modality
 */
CandidateOfferItem.prototype['modality'] = undefined;

/**
 * @member {String} date
 */
CandidateOfferItem.prototype['date'] = undefined;

/**
 * id tipo de contrato
 * @member {Number} contract_type
 */
CandidateOfferItem.prototype['contract_type'] = undefined;

/**
 * duración del trabajo
 * @member {String} length
 */
CandidateOfferItem.prototype['length'] = undefined;

/**
 * bruto año, neto al mes, ...
 * @member {String} salary_type
 */
CandidateOfferItem.prototype['salary_type'] = undefined;

/**
 * @member {Number} salary_min
 */
CandidateOfferItem.prototype['salary_min'] = undefined;

/**
 * @member {Number} salary_max
 */
CandidateOfferItem.prototype['salary_max'] = undefined;

/**
 * @member {String} city
 */
CandidateOfferItem.prototype['city'] = undefined;

/**
 * @member {String} state
 */
CandidateOfferItem.prototype['state'] = undefined;

/**
 * @member {Boolean} is_remote_process
 */
CandidateOfferItem.prototype['is_remote_process'] = undefined;

/**
 * @member {String} presence
 */
CandidateOfferItem.prototype['presence'] = undefined;

/**
 * esto es para cuando el alumno está inscrito [P_A_12], si no viene vacio
 * @member {Array.<module:model/Event>} events
 */
CandidateOfferItem.prototype['events'] = undefined;

/**
 * Estado actual de la candidatura, si no esta inscrito viene null
 * @member {String} status
 */
CandidateOfferItem.prototype['status'] = undefined;

/**
 * tipo de horario
 * @member {Number} schedule
 */
CandidateOfferItem.prototype['schedule'] = undefined;

/**
 * el curso del alumno es compatible con la oferta
 * @member {Boolean} academic_matching
 */
CandidateOfferItem.prototype['academic_matching'] = undefined;






export default CandidateOfferItem;

